module.exports = __webpack_public_path__ + "static/media/funntee_logo.1085ba80.svg";